import React, { useEffect } from 'react'
import AllGamesLobby from '../../components/Lobby/AllGamesLobby'
import './styles/index.scss'
import useCasinoMenuList from './hooks/useCasinoMenuList'
import Banner from '../../components/Banner'
import AboutUs from '../../components/AboutUs'
import { GAME_CARD_VARIANTS } from 'constants/uiConfig'
import { useSelector } from 'react-redux'

const CasinoPage = ({ selectedFilter, setSelectedFilter }) => {
  const {
    showAboutUsInLobby,
    showBanner,
    categorySlug,
    categoryId
  } = useCasinoMenuList()

  const uiConfig = useSelector(state => state?.uiConfig?.general)
  const isV3Variant = uiConfig?.gameCardVariant === GAME_CARD_VARIANTS.V3

  useEffect(() => {
    setSelectedFilter(selectedFilter => ({
      ...selectedFilter,
      search: ''
    }))

    // Scroll to top when component mounts (e.g., when navigating from other pages)
    window.scrollTo(0, 0)

    return () => {
      setSelectedFilter({
        limit: isV3Variant ? 32 : 30,
        pageNo: 1,
        category: null,
        subCategoryId: null,
        search: '',
        rating: [],
        provider: [],
        studio: []
      })
    }
  }, [])

  return (
    <>
      <div className='casino-page-section'>
        {showBanner && (
          <section className='main-container-wrapper wrapper-content banner'>
            <Banner pageType='casino' categoryId={categoryId} anchorTagFilterType='casinoBannerJoinNow' setSelectedFilter={setSelectedFilter} />
          </section>
        )}

        <section className={`main-container-wrapper-inner wrapper-content casino-page ${!showBanner ? 'top-section' : ''}`}>
          <div className='games-content'>
            <AllGamesLobby categorySlug={categorySlug} selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} />
          </div>
        </section>

        {showAboutUsInLobby && (
          <div className='main-container-wrapper-inner'>
            <AboutUs />
          </div>
        )}

      </div>
    </>
  )
}

export default CasinoPage
